import { ListingResponse } from '~/modules/services/listing_service';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
import { BadgeKey } from './badgeHelper';

type AgentforceFeature = 'numAgents' | 'numTopics' | 'numActions';

type AgentforceFeatureCheckProps = {
    listing: ListingResponse;
    extension?: schema.oaf.Force_Listing;
};

type AgentforceFeatureCheck = ({ listing, extension }: AgentforceFeatureCheckProps) => string | undefined;

const AgentforceFeatureChecks: AgentforceFeatureCheck[] = [
    getSimpleFeature('numAgents'),
    getSimpleFeature('numTopics'),
    getSimpleFeature('numActions'),
];

/**
 * @param listing
 * @returns array with supported features as badge keys to map from localization file based on direct oAF field mappings
 */
export function selectAgenticDetails(listing: ListingResponse): BadgeKey[] {
    const extension = selectExtensionListing(listing);
    const agenticDetails: BadgeKey[] = [];
    for (const checkFunction of AgentforceFeatureChecks) {
        const realValue = checkFunction({ listing, extension });
        if (realValue) {
            agenticDetails.push(realValue as BadgeKey);
        }
    }
    return agenticDetails;
}

function getSimpleFeature(field: AgentforceFeature): AgentforceFeatureCheck {
    return ({ extension }) => {
        if (!extension || !(field in extension)) {
            return undefined;
        }
        const value = extension[field as keyof typeof extension];
        return value ? field : undefined;
    };
}
